import configurl from '@/config/user.env';
import { importApi } from '@/modules/mdm/api/targetModdeules/monthProgressReport.js';
import { templateDownloadApi } from '@mdm/api/customer/customerPersonResponsibleImport';
export const importConfigOpt = {
    action: configurl.apiUrl + 'api-lcrm/contractEnclosureInfo/upload',
    downloadApi: templateDownloadApi,
    importApi: importApi,
    downParams: {
        fileName: '月度进度导入模板.xlsx',
        fileId: 'goalMonthlyProgressAddImport.xlsx'
    },
    multiple: false,
    accept: 'xlsx',
    downBtn: true,
    showFileList: false,
    fileType: '只能上传Excel文件',
    manualUpload: true
};
